<template>
  <div class="daohan">
    <div class="frist-loit">
      <div @click="kefu">
        <img class="kefu_img" src="../assets/kefu (2).png" alt />
        <div>联系客服</div>
      </div>
      <div @click="xiazai">
        <img class="kefu_img" src="../assets/phong.png" alt />
        <div>下载APP</div>
      </div>
      <div @click="stop">
        <img class="zhiding" src="../assets/img/img_60.png" alt />
      </div>
    </div>
    <div class="xiazia-app" v-if="slid">
      <div class="erweima">
        <img :src="imgs.downloadimage" alt />
        <div class="xiazai-text">
          扫码下载APP
          <br />随时随地在手机上学习课程
        </div>
      </div>
      <div class="quxiao-icon">
        <img src="../assets/xiazai-quxiao.png" alt @click="quxiao" />
      </div>
    </div>
    <div class="kefu-i" v-if="i">
      <div class="kefu-icon">
        <div class="lianxi-kefu">联系客服</div>
        <img class="erwima-kefu" :src="service.image" alt />
        <div class="saomiao">扫描添加客服微信</div>
        <div class="kefu-phong">
          <div class="phong-left">
            <div class="kehu">客服电话</div>
            <div class="zuoji">{{ service.phone1 }}</div>
            <div class="shouji">{{ service.phone2 }}</div>
          </div>
          <div class="phong-right">
            <div class="kehu">工作时间</div>
            <div class="shoujip">{{ service.worktime }}</div>
          </div>
        </div>
      </div>
      <div class="guanbi">
        <img src="../assets/xiazai-quxiao.png" alt @click="guanbi" />
      </div>
    </div>
    <!-- 整个背景阴影  @click="quxiaok"-->
    <div class="zhexiu-ceng" v-if="to"></div>
    <div class="kefuchuan" v-if="showimg">
      <img
        class="fefuchuang-que"
        @click="kefuquxiao"
        src="../assets/img/img_59.png"
        alt
      />
      <div class="kefuchuan-list" v-for="(item, index) in kefui" :key="index">
        <div class="kefuchuang-left">
          <img src="../assets/img/img_61.png" class="kefu-img" alt />
          <div class="kefuchuang-name">{{ item.name }}</div>
        </div>
        <div class="quzixun" @click="quzi(item.id)">查看联系方式</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slid: false,   // 下载app 弹窗
      i: false,
      to: false,   // 整个背景
      service: [],
      kefui: [],
      showimg: false,
      imgs: []
    };
  },
  mounted() {
    // this.getkefu();
    this.getkefu();
    this.lianxi()
  },
  methods: {
    //返回顶部
    stop() {
      document.getElementById("app").scrollIntoView();
    },
    quzi(id) {
      this.showimg = false
      this.i = true
      let that = this;
      var url = "lists/ke_list_detail";
      let param = {
        id: id
      };
      this.post(url, param)
        .then((res) => {
          that.service = res.data
          console.log(that.service);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    lianxi() {
      let that = this;
      var url = "index/kefu";
      this.post(url)
        .then((res) => {
          that.imgs = res.data

        })
        .catch((err) => {
          console.log(err);
        });
    },
    //打开下载弹窗
    xiazai() {
      this.slid = true;
      this.to = true;
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    parentHandleclick(e) {
      console.log(e)
      this.xiazai()
    },
    //咨詢客服列表
    getkefu() {
      let that = this;
      var url = "lists/ke_list";
      let param = {};
      this.post(url)
        .then((res) => {
          that.kefui = res.data.info;
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //取消下载
    quxiao() {
      this.slid = false;
      this.to = false;
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    kefuquxiao() {
      this.showimg = false;
      this.to = false;
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    quxiaok() {   // 关闭联系客服
      this.slid = false;
      this.to = false;
      this.i = false;
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    //联系客服
    kefu() {
      this.showimg = true;
      this.to = true;
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    //关闭客服弹窗
    guanbi() {
      this.i = false;
      this.to = false;
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },

    // getkefu() {},
  },
};
</script>
<style scoped>
.quzixun {
  width: 111px;
  height: 34px;
  background: #2d52b1;
  border-radius: 17px;
  text-align: center;
  line-height: 34px;
  color: #ffffff;
  font-size: 14px;
}
.kefuchuang-name {
  margin-left: 19px;
  font-size: 18px;
  color: #06121e;
}
.fefuchuang-que {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 20px;
  right: 20px;
}
.kefu-img {
  width: 30px;
  height: 30px;
}
.kefuchuang-left {
  display: flex;
  align-items: center;
  justify-content: center;
}
.kefuchuan-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 13px 8px 24px;
  box-sizing: border-box;
  background: #f9f9f9;
  margin-bottom: 17px;
}
.frist-loit {
  width: 60px;
  height: 204px;
  position: fixed;
  top: 50%;
  right: 0;
  transform: translate(-50%);
  z-index: 90;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}
.kefuchuan {
  width: 538px;
  height: 485px;
  background: #ffffff;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  padding: 55px 34px 50px 34px;
  box-sizing: border-box;
  border-radius: 24px;
}
.frist-loit div {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #2d52b1;
  border-radius: 4px;
  box-shadow: 0px 4px 8px 0px rgba(240, 131, 0, 0.16);
}
.frist-loit div div {
  font-size: 10px;
  color: #ffffff;
}
.kefu_img {
  width: 30px;
  height: 30px;
  margin-top: 8px;
}
.zhiding {
  width: 100% !important;
  height: 100% !important;
}
.xiazia-app {
  width: 385px;
  height: 520px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  /* background-color: red; */
}
.erweima {
  width: 385px;
  height: 440px;
  background: #ffffff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 53px 62px 52px 63px;
  box-sizing: border-box;
}
.erweima img {
  width: 260px;
  height: 260px;
}
.xiazai-text {
  font-size: 16px;
  color: #06121e;
  margin-top: 33px;
  text-align: center;
}
.quxiao-icon img {
  width: 24px;
  height: 24px;
  margin-top: 68px;
}
.kefu-icon {
  width: 385px;
  height: 617px;

  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 38px 17px 40px 18px;
  box-sizing: border-box;
  background-image: url("../assets/kefutupian.png");
  background-size: 100% 100%;
}
.kefu-i {
  width: 385px;
  height: 670px;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
.lianxi-kefu {
  font-size: 22px;
  color: #ffffff;
}
.erwima-kefu {
  width: 260px;
  height: 260px;
  margin-top: 47px;
}
.saomiao {
  font-size: 16px;
  color: #06121e;
  margin-top: 27px;
}
.kefu-phong {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 29px;
}
.phong-left {
  width: 168px;
  background: #f9f9f9;
  border-radius: 20px;
  padding: 10px 16px 21px 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.phong-right {
  width: 168px;
  background: #f9f9f9;
  border-radius: 20px;
  padding: 15px 16px 32px 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.kehu {
  font-size: 18px;
  color: #06121e;
}
.zuoji {
  font-size: 14px;
  color: #06121e;
  margin-top: 15px;
}
.shouji {
  font-size: 14px;
  color: #06121e;
  margin-top: 11px;
}
.shoujip {
  font-size: 14px;
  color: #06121e;
  margin-top: 32px;
}
.guanbi img {
  width: 24px;
  height: 24px;
  margin-top: 63px;
}
.zhexiu-ceng {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0.6;
  background: #06121e;
  z-index: 999;
}
</style>